import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import RadioButtonGroup2 from "../../RadioButtonGroup/RadioButtonGroupimpedance/RadioButtonGroup2";
import "./FieldStyles.css";
import {Link} from "react-router-dom";
import DesignImageVertical from "../../../../../assets/img/panelByJlcpcb.png";

let panel = [
    {
        id: 1,
        checked: false,
        disabled: false,
        name: "panelFlag",
        text: <FormattedMessage id="app.pcb-quotation.pcb-panels-yes"
                                defaultMessage="Yes" description=""/>
    },
    {
        id: 0,
        checked: true,
        disabled: false,
        name: "panelFlag",
        text: <FormattedMessage id="app.pcb-quotation.pcb-panels-no"
                                defaultMessage="No" description=""/>
    },
];

let NoPanel = [
    {
        id: 1,
        checked: false,
        disabled: true,
        name: "panelFlag",
        text: <FormattedMessage id="app.pcb-quotation.pcb-panels-yes"
                                defaultMessage="Yes" description=""/>
    },
    {
        id: 0,
        checked: true,
        disabled: false,
        name: "panelFlag",
        text: <FormattedMessage id="app.pcb-quotation.pcb-panels-no"
                                defaultMessage="No" description=""/>
    },
];

let setParamOnChange = (e) => {

    let reg = new RegExp('^[1-9]([0-9]*)(\.[0-9]{0,1})?$');
    // let reg = new RegExp('^[1-9]([0-9]*)(\\.\\d{1,2})?$');
    if (!reg.test(e.target.value)) {
        e.target.value = "";
        e.target.placeholder = 0;
        return;
    }

    this.props.setPCBParams({name: e.target.name, id: parseInt(e.target.value)});
};

const PanelWidth = (props) => {

    /*const handleInput = (e) => {
            props.setPCBParams({name : e.target.name, id : parseInt(e.target.value)});
    };*/

    return (
        <div className="panel-sizes panel-size-mobile">
            <div className="row">
            <span className="form-group xx-div-group-first">
                    <span className="input-group-addon xx-div-label">X :</span>
                    <span className="xx-div-group">
                <div className="input-group input-zindex-set">
                    <input
                        value={props.panelByJLCPCB_X}
                        type="text" className="form-control xx-div-input color-text-green"
                        name="panelByJLCPCB_X" onChange={props.setPanelSizes} onBlur={props.onInputBlur}/>
                    <span className="input-group-addon xx-div-span">
                        {props.setValueX}mm
                    </span>
                </div>
                    </span>
            </span>
                <span className="form-group xx-div-group-two">
                <span className="input-group-addon xx-div-label">Y :</span>
                <span className="xx-div-group">
                <div className="input-group input-zindex-set">
                    <input
                        value={props.panelByJLCPCB_Y}
                        type="text" className="form-control xx-div-input color-text-green"
                        name="panelByJLCPCB_Y" onChange={props.setPanelSizes} onBlur={props.onInputBlur}/>
                    <span className="input-group-addon xx-div-span">
                       {props.setValueY}mm
                    </span>
                </div>
                </span>

                </span>
                <div>&nbsp;
                    <a>
                        <FormattedMessage id="app.pcb-quotation.pcb-different-design-caption"
                                          defaultMessage="For example"
                                          description=""/>
                        <link id="pcbstnclSide-qLink"
                            to={{pathname:"https://kitcutlabo.com/panelhelp/"}} target="_self"
                            className="glyphicon glyphicon-question-sign question-link"></link>

                        <div className="img-responsive ex-img"><img alt="image" src={DesignImageVertical} width="255px"
                                                                    height="350px"/></div>

                    </a>
                </div>
            </div>
        </div>
    );
};

class PanelByJLCPCB extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // panel_X : 1,
            // panel_Y : 1,
            panel_X: props.pcbParam.panelByJLCPCB_X,
            panel_Y: props.pcbParam.panelByJLCPCB_Y,
            panel_X_event: null,
            panel_Y_event: null,
        };
        this.setPanelSizes = this.setPanelSizes.bind(this);
        this.onInputBlur = this.onInputBlur.bind(this);
    }
    componentDidMount() {
        if (this.state.panel_X === 0) {
            this.setState({
                panel_X: 1
            })
        }
        if (this.state.panel_Y === 0) {
            this.setState({
                panel_Y: 1
            })

        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({
                panel_X: this.props.pcbParam.panelByJLCPCB_X,
                panel_Y: this.props.pcbParam.panelByJLCPCB_Y
            })
        }
    }

    onInputBlur = (event) => {
        let regex = new RegExp('^[1-9]([0-9]*)(\.[0-9]{0,1})?$');
        if (regex.test(event.target.value)) {
            if (event.target.name === "panelByJLCPCB_X") {
                this.props.setPCBParams({name: "panelByJLCPCB_X", id: parseInt(this.state.panel_X)});
            } else {
                this.props.setPCBParams({name: "panelByJLCPCB_Y", id: parseInt(this.state.panel_Y)});
            }
        } else {
            this.setState({
                panel_X: this.props.panelByJLCPCB_X,
                panel_Y: this.props.panelByJLCPCB_Y,
            })
        }
    };

    setPanelSizes = (event) => {
        var rex = /[\uFF10-\uFF19]/g;

        let val2 = event.target.value;

        val2 = val2.replace(rex, function(ch) {
            return String.fromCharCode(ch.charCodeAt(0) - 65248);
        });

        let fVal = val2.replace(/\s/g, '');
        fVal = fVal.replace(/\u002E/g, "");
        fVal = fVal.replace(/\u3002/g, "");

        if (event.target.name === "panelByJLCPCB_X") {
            this.setState({
                panel_X: fVal,
                panel_X_event: event
            })
        } else {
            this.setState({
                panel_Y: fVal,
                panel_Y_event: event
            })
        }
    };

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if(prevProps.selectedId !== this.props.selectedId){
    //         this.setState({
    //             panel_X : 1,
    //             panel_Y : 1
    //         })
    //     }
    // }

    render() {
        let selectedPanel = panel.map((item) => {
            item.checked = (item.id === this.props.selectedId);
            if (this.props.thickness === 0.4) {
                item.disabled = item.id === 1;
            } else {
                item.disabled = false;
            }
            return item;
        });

        return (
            <div className="row">
                <div className="col-md-12 no-padding">
                    <div className="pcb-details-div">
                        <div className="col-md-3 text-right content-item-heading">
                            <FormattedMessage id="app.pcb-quotation.pcb-panel"
                                              defaultMessage="Panel By JLCPCB"
                                              description=""
                            />
                            &nbsp; &nbsp;
                            <Link id="panelBy-qLink"
                                to={{pathname:"https://kitcutlabo.com/panelhelp/"}} target="_self"
                                className="glyphicon glyphicon-question-sign question-link"></Link>
                        </div>
                        <div className="btn-group col-md-9 pcb-details-div-items">
                            <div className="col-md-4 no-padding radio-btn-pcb-panel">
                                {/*{this.props.thickness === 0.4 ?*/}
                                {/*    <RadioButtonGroup2 data={NoPanel} getParams={this.props.setPCBParams}/>*/}
                                {/*    :*/}
                                {/*    ''*/}
                                {/*}*/}
                                    <RadioButtonGroup2 data={NoPanel} getParams={this.props.setPCBParams}/>
                                {/*{this.props.thickness > 0.4 ?*/}
                                {/*    <RadioButtonGroup2 data={selectedPanel} getParams={this.props.setPCBParams}/>*/}
                                {/*    :*/}
                                {/*    ''*/}
                                {/*}*/}
                            </div>
                            <div className="col-md-8 pcb-panel-options">
                                {/*{console.log("panely byyyy ", props)}*/}
                                {this.props.selectedId === 1 ? <PanelWidth setValueX={this.props.selectedSizeX}
                                                                           setValueY={this.props.selectedSizeY}
                                                                           panelByJLCPCB_X={this.state.panel_X}
                                                                           handleInput={this.props.handleInput}
                                                                           panelByJLCPCB_Y={this.state.panel_Y}
                                                                           setPanelSizes={this.setPanelSizes}
                                                                           onInputBlur={this.onInputBlur}
                                                                           setPCBParams={this.props.setPCBParams}/> : ''}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PanelByJLCPCB;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/PanelByJLCPCB.js